"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var InDelivery32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M12.5 13.5a.5.5 0 01.264.076l.075.056 8.381 7.715c1.117 1.02 1.297 2.14.417 3.17-.94.973-2.01 1.016-2.988.134l-.133-.125-7.056-6.933a.5.5 0 01.631-.77l.07.057 7.058 6.935c.624.62 1.107.62 1.678.03.45-.528.403-1.017-.228-1.642l-.125-.12-8.235-7.58-.03.001a5.5 5.5 0 00-5.275 5.275L7 20v7.562a.5.5 0 01-.992.09L6 27.561V20a6.5 6.5 0 016.5-6.5zM15 22a.5.5 0 01.492.41l.008.09v5a.5.5 0 01-.992.09l-.008-.09v-5a.5.5 0 01.5-.5zm11.5-10.5a.5.5 0 01.492.41L27 12v9a.5.5 0 01-.41.492l-.09.008h-4.017a.5.5 0 01-.09-.992l.09-.008H26v-8h-8v3.506a.5.5 0 01-.41.492l-.09.008a.5.5 0 01-.492-.41l-.008-.09V12a.5.5 0 01.41-.492l.09-.008h9zm-14-8A4.502 4.502 0 0116.889 7H20a.5.5 0 01.09.992L20 8h-3a4.5 4.5 0 11-4.5-4.5zM16 8H9a3.5 3.5 0 007 0zm-3.5-3.5A3.502 3.502 0 009.145 7h6.71A3.502 3.502 0 0012.5 4.5z" }))); };
var StyledInDelivery32 = styled_components_1.default(InDelivery32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledInDelivery32;
var templateObject_1;
//# sourceMappingURL=InDelivery32.js.map